import { render, staticRenderFns } from "./complaint_suggestion_detail.vue?vue&type=template&id=ef8727ca&scoped=true"
import script from "./complaint_suggestion_detail.vue?vue&type=script&lang=js"
export * from "./complaint_suggestion_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8727ca",
  null
  
)

export default component.exports